var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDailytrades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_440_1122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6964 30.8354L44.049 23.188C42.9449 22.084 41.1539 22.084 40.0482 23.188L25.6986 37.5376C25.1441 38.0921 25.1441 38.991 25.6986 39.5455L27.6916 41.5384C28.2461 42.0929 29.1449 42.0929 29.6994 41.5384L42.0478 29.1901L49.6951 36.8374C50.7992 37.9415 52.5902 37.9415 53.6959 36.8374L67.9445 22.5888L71.6805 26.3248C72.6124 27.2567 74.2081 26.7419 74.4183 25.4409L76.643 11.7451C76.8201 10.656 75.8783 9.71411 74.7891 9.89122L61.0933 12.1159C59.7923 12.3278 59.2775 13.9218 60.2094 14.8537L63.9454 18.5897L55.7965 26.7386",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6943 13.3325H33.1685",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9321 11.0945V15.5704",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.8694,
    cy: 21.9334,
    r: 1.24146,
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8242 75.4168C35.6417 74.9815 37.4443 74.4319 39.0367 73.9486C44.999 72.1394 50.7626 77.1648 60.9227 73.3924",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.011 50.7698C73.011 50.7698 73.7906 60.8538 68.7139 67.7761",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3499 71.6543C21.6563 64.4853 25.384 58.1258 33.1241 57.9056C40.8641 57.6855 45.052 57.1475 48.096 49.563C51.1384 41.9802 60.3782 38.4131 71.8823 40.3084L75.7226 39.1646C76.772 38.8518 77.9059 39.2126 78.5812 40.0767L85.4076 48.8066C85.9108 49.4488 85.8677 50.3625 85.3066 50.9568L84.0502 52.286C83.6795 52.6783 83.1398 52.8653 82.6068 52.7842C81.7362 52.6534 80.301 52.4316 78.7782 52.1585",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7778 63.9557C56.7778 63.9557 65.9729 64.9406 68.714 67.7761C71.4552 70.6116 66.3486 80.9157 66.3486 80.9157C63.4701 80.338 61.3166 77.9296 61.0633 75.0031L60.9243 73.3908",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4547 71.1727C35.4547 71.1727 33.7018 78.5403 27.6766 83.0145C24.6756 85.2425 20.4861 84.9081 17.8228 82.2878C17.8228 82.2878 22.5933 78.9508 22.3516 71.656",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4959 73.6242C43.4959 73.6242 42.7759 79.5071 38.2636 83.5559C35.9214 85.6564 32.3327 85.5223 30.1494 83.2563C30.1494 83.2563 31.3412 81.1673 32.2119 78.1928",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5243 58.2417L73.5638 58.245C75.0354 58.25 76.4341 58.6969 77.6043 59.4815C78.7763 60.2661 79.7214 61.39 80.2859 62.749L68.7139 67.7761",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9283 32.1578C72.9283 32.1578 67.6679 35.0065 71.8822 40.3084",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5813 38.9909C84.5813 38.9909 83.6511 41.9174 80.2412 42.1988",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2876 62.749L81.4562 65.0399C81.779 65.6739 81.8734 66.4022 81.7211 67.0974L81.1185 69.8551",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3487 80.9174C66.3487 80.9174 64.263 85.0953 62.2188 86.5387",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8225 82.2861L14.7023 84.5737C13.9144 85.1514 13.6429 86.2042 14.0518 87.0914L16.3824 92.1334",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1494 83.2562L27.6267 86.0983C27.0375 86.762 26.9414 87.7287 27.3884 88.4968L29.5104 92.1351",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_440_1122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.3798,
    height: 84.7501,
    fill: "white",
    transform: "translate(12.6201 8.62494)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDailytrades);
export default __webpack_public_path__ + "static/media/icon_dailytrades.8e63b03115f106de8d9944fd3122c63c.svg";
export { ForwardRef as ReactComponent };